export default __webpack_public_path__ + "static/1_36-b890fb53e739dcb57e1f1ab7d28e6e43.png";